module.exports = __webpack_public_path__ + "static/media/inside-right.6eeaed4b.jpg";